module.exports = __webpack_public_path__ + "img/ncffa-basf-logo.4ee8625b.jpg";